export default {
  home: [
    {
      title: "FREEZE DRIED",
      subtitle: [
        "YOU COULD FIND ALL",
        "DRIED FRUIT AND VEGETABLE",
        "WITH NATURAL INGREDIENTS",
      ],

      title1: "SEMI DRIED",
      title2: "FREEZE DRIED",
      title3: "VACUUM FRIED",
    },
    {
      title: "WHY WORK WITH GREEN CRISPY",
      button: "Specialize",
      item1: {
        title: "QUALITY CONTROL",
        text: "HACCP, BRC, ISO, HALAL certificated. A+ grade material are from trusted bases, registered in China Customs System.",
        description:
          "6 times selection process in each production: foreign body, color, shape, size, metal detection, broken ratio.",
      },
      item2: {
        title: "CUSTOMIZED SOLUTION",
        text: "One-stop OEM service to support brand clients: variety, color, shape, size, package etc.",
        description:
          "Customization solution for food manufacturing clients: baking, chocolate, cereal, ice cream, candy etc.",
      },
      item3: {
        title: "ABILITY",
        text: "16 people R&D team to support clients' great ideas achievement: process method, ingredient list, new flavor etc.",
        description:
          "Communicate with brands STARBUCKS, AMWAY etc, to learn the trend of global snack market.",
      },
    },
    {
      item: {
        title: "EXPLORE OUR PRODUCTS",
        text: " Our company believe that natural ingredients could bring health to clients and consumers including kids, pregnant, elderly. We focus on the super foods supplying in high end process method: freeze dried, vacuum fried, toasted dried, semi dried etc, max keeping the nutrition of fresh fruit and vegetable.",
        description:
          " Natural, Vegan, Gluten free, Non-GMO, HALAL, No additive, No preservative, no artificial colors. Each ingredient of each product should be confirmed, natural.",
      },
      button: "Go To Brochures",
    },
    {
      title: "OUR CERTIFICATIONS",
    },
    {
      title: "OUR TEAM",
      text: "We believe that if we do more, clients could do less. That's how we build long term cooperation with each client. We are good at solving and avoiding problems to save the time and cost of clients.",
      description:
        " Everybody in Green Crispy is honest, hard working, keeping learning, keeping optimistic attitude, taking good care of each order. We regard client's business as ourselves thing. Together with us, everything will be better and easier. You can rest easy knowing that we will get the job done right.",
      button: "More About US",
    },
    {
      title: "COOPERATION PARTNER",
    },
    {
      button: "Visit our shop",
    },
    'chat',
    'top'
  ],
  qualityControl: [
    {
      item1: {
        title: "A+ GRADE RAW MATERIAL",
        text: "We believe good products are made from premium material. All fruit and vegetable material are from trusted bases, registered in China Customs System. Pesticide residues, heavy metals are tested in each batch material,meeting the requirements of US, EU, Middle East, Southeast Asia.",
      },
      item2: {
        title: "GLOBAL FOOD SAFETY SYSTEM",
        text: "We produce strictly based on global standard HACCP, BRC, ISO, HALAL. We consider global laws and regulations of food safety as the strong basis. It has established an internal control system, which covers all links and processes including supply, production, transportation and sales, to achieve systematic management of food safety.",
      },
      item3: {
        title: "AUTOMATIC PRODUCTION MACHINES",
        text: "There are five categories of facilities and machines, including freeze dried facility, vacuum fried facility, seasoning facility, disinfection facility and packaging facility, which includes automatic production facilities like packaging facility to partly replace manual operation.",
      },
      item4: {
        title: "REGULAR LAB TESTS",
        text: "Not only test in factory lab, issuing COA to help clients know quality detail, also cooperate with global standard labs like: Merieux, Eurofins, SGS, to get the accurate test data and achieve food safety.",
      },
      item5: {
        title: "STRICT SELECTION PROCESS",
        text: "6 times selection process in each production from the following aspects: foreign body, color, shape, size, metal detection, broken ratio, to ensure the food safety and quality. ",
      },
    },
  ],
  cataLog: [
    "FREEZE DRIED FRUIT", //1
    "FREEZE DRIED CANDY", //5
    "VACUUM FRIED PRODUCTS", //2
    "TOASTED DRIED FRUIT", //4
    "SEMI DRIED PRODUCT", //3
    "HAZELNUT & CHESTNUT", //6
    "VIEW PRODUCTS",
    "CATALOG",
  ],
  abouts: [
    {
      title1: "COOPERATION PARTNER",
      title: "ABOUT US",
      title2: "GLOBAL CLIENTS’ MAP",
      introduceInfo: [
        {
          title: "MISSION",
          text1:
            "Connect human civilization with healthy food. How to define healthy food? It is from 100% natural ingredients, no any additive.",
          text2:
            "We hope all global consumers could enjoy high quality food. How to define high quality food? It is after Green Crispy 6 times quality control.",
        },
        {
          title: "VISION",
          text1:
            "Build a trusted global supply chain of healthy food and be committed to the well-being, growth and success of clients and employees.",
          text2:
            "We respect business and brand of each client, aiming to help clients to expand market. We take good care of each one of our team.",
        },
        {
          title: "CORE VALUE",
          text1:
            "We are a client-centric and innovation-driven organization with integrity and virtue. Keep an open mind during cooperation.",
          text2:
            "We are reliable for food safety. We respect country regulation, religious belief etc. All truth details should let clients know well.",
        },
      ],
      jieshao: [
        { dw: "YEAR", js: "Establishment" },
        { dw: "PEOPLE", js: "Current Employees" },
        { dw: "AREA", js: "Exporting Countries" },
        { dw: "MAIN TYPE", js: "Product System" },
        { dw: "ITEM", js: "Product Items" },
      ],
    },
  ],
  inspectionReport: [
    {
      title: "INSPECTION REPORT",
      down: "DOWN",
    },
  ],
  customizedSolution: [
    {
      list: [
        {
          title: "ONE-STOP OEM SOLUTION FOR SNACK BRANDS CLIENTS",
          nrList: [
            "One-stop OEM service to support brand clients selling on platform like Amazon. We could supply professional service for brand client: stickers, bag design, bag print, display box, master carton etc. Whether you want to build a new brand or expand business, welcome to cooperate with us.",
          ],
        },
        {
          title: "INGREDIENTS SOLUTION FOR FOOD MANUFACTURING",
          nrList: [
            "Ingredients solution for food manufacturing industries: baking, chocolate, ice cream, cereal, candy. We could develop new ingredients from: variety, shape, size, color to meet different food manufacturing.",
          ],
        },
        {
          title: "HIGH QUALITY PACKAGE",
          nrList: [
            "We choose food grade aluminum foil bag. To keep less breakage during shipping, we add bubble wrap in carton. fragile sticker on carton, wrapping film and pallet to protect carton and make the lowest breakage. Before loading goods, we check, clean, reinforce container. Make sure safe shipping.",
          ],
        },
      ],
    },
  ],
  rd: [
    {
      list: [
        {
          title: "16 PEOPLE R&D TEAM",
          nrList: [
            "Professional R&D team support clients’ great ideas achievement from process method, ingredient list, new flavor etc. 3 snacks are launched each month, helping clients expand market.",
          ],
        },
        {
          title: "COMMUNICATE WITH GLOBAL BRANDS",
          nrList: [
            "Keep contacting with brands such as STARBUCKS, AMWAY, MONDELEZ, communicating the trend of global snack market. Knowing the culture difference in each country, then provide suitable solution. ",
          ],
        },
      ],
    },
  ],
  cooperationCase: [
    {
      title: "COOPERATION CASE",
      list: [
        {
          title:
            "CUSTOMIZED SOLUTION FOR VEGETABLE CHIPS WITH RICE BRAN OIL FOR UAE MARKET",
          nrList: [
            "In vacuum frying production, palm oil is widely used due to it's stable performance. If consider health factor, palm oil is not be loved by consumers, because saturated fat is around 50% in palm oil.",
            "To provide a healthier solution for UAE clients, we tested all plant oil finally choose rice bran oil. Rice bran oil contain less saturated fat, around 20g per 100g, which has sweet taste and is better for heart, blood health. Vegetable chips contain less oil and has better crispy, better taste, better health.",
            "Customized Solution: Vacuum fried vegetable, rice bran oil",
          ],
          smtitle: "VACUUM FRIED, UAE",
        },
        {
          title: "OEM TEMPURA SEAWEED CHIPS FOR AUSTRALIA MARKET",
          nrList: [
            "Seaweed chips are popular in global. But the taste is not enough because it's thickness. Our team try many ways to explore how to make seaweed chips better tasty and crispy. After more than 20 tests, finally we developed vacuum fried tempura series for Australia clients, a perfect combination of tempura batter and seaweed. The best crispy and good seaweed taste. Don't hesitate to try our wasabi flavor seaweed chips, it's excellent.",
            "OEM Package method: 50g per unit, 6 units per display box, 6 boxes per carton",
          ],
          smtitle: "VACUUM FRIED, AUSTRALIA",
        },
        {
          title: "OEM MIX VEGETABLE CHIPS FOR ISRAEL MARKET",
          nrList: [
            "When it comes to vegetable chips, consumers like eating different vegetable chips in one bag. Not only enjoy vegetable but also enjoy beautiful colors. Consumers like food with good look.",
            "We totally understand and professional at this. So we developed a variety of mixed vegetable chips for Israeli customers, different shapes, with salty, wasabi etc flavors. Considering health and taste, these vegetable chips are fried by rice bran oil. These bag designs are attractive, right? ",
            "OEM Package method: 40g per unit, 10 units in a transparent bag, 4 bags per carton",
          ],
          smtitle: "VACUUM FRIED, ISRAEL",
        },
        {
          title:
            "CUSTOMIZED SOLUTION LOW MALTOSE MUSHROOM CHIPS FOR THAILAND MARKET",
          nrList: [
            "Maltose is a necessary ingredient in vacuum frying process, which is helpful for keeping the origin color, origin shape of fresh fruit, vegetable and mushrooms. But now, consumers do not like eating too much sugar in their diet, so we developed low maltose mushroom chips, to help consumers enjoy both tasty and healthy. You can't find the difference from the shape, color, taste. When we look into the nutrition composition table, we could find sugar in a very low level. That's great for consumers.",
            "Customized Solution: Vacuum fried mushroom, low maltose",
          ],
          smtitle: "VACUUM FRIED, THAILAND",
        },
        {
          title:
            "CUSTOMIZED SOLUTION 1G FREEZE DRIED YOGURT FOR THAILAND GRANOLA MARKET",
          nrList: [
            "Freeze dried yogurt is good for granola products. How to evenly pack yogurt cubes into every bag granola, avoiding some bags have many freeze dried but some bags has less freeze dried yogurt ? According to Thailand client's requirements, we developed freeze dried yogurt in 1g. Usually it's 1.3g and 3g per block. Small size is helpful for client to put yogurt blocks evenly in each granola bag. Here are 5 flavors freeze dried yogurt available: strawberry, blueberry, mango, peach, dragon fruit.",
            "Customized Solution: Freeze dried yogurt, granola ",
          ],
          smtitle: "FREEZE DRIED, THAILAND",
        },
      ],
    },
  ],
  control: [
    "CONTACT US",
    "REACH US",
    "Tianjin Green Crispy Foods",
    "712, Wuyue Plaza B, Erba Road, Jinnan District, Tianjin, China,300350",
    "tyler@greencrispy.com",
    "+86 13512282858",
    "Monday to Friday - 9 am to 6 pm",
    "SOCIAL",
    "SEND US A MESSAGE",
    "Name",
    "Email",
    "Message",
    "SEND",
    'Please Write Your Name!',
    'Please Write Your Email!',
    'Please Write Message!',
    'Please enter your email address in the correct format！',
    'Email Send SUCCESS!',
    'Email Send ERROR!',
  ],
  shopHome: [
    "WORTH TRYING",
    "VIEW MORE",
    "HOT SELLING PRODUCTS",
    "CHECK OUR LATEST",
    "NEW ARRIVALS",
    "Show All Products",
    "Freeze Dried Product",
    "Vacuum Fried Product",
    "Toasted Dried Produc",
    "Hazelnut & Chestnut",
  ],
  shop: [
    {
      public: ["Hot Product", "Out Of Stock", "Get Price"],
      freezeDried: [
        "SHAPE FILTER",
        "WHOLE",
        "SLICE",
        "GRANULE",
        "POWDER",
        "SNACK <br> <span class='xgys'>(READY TO EAT)</span>",
        "INGREDIENTS <br> <span class='xgys'>(FOOD MANUFACTURING)</span>",
        "Hot Product",
        "Out Of Stock",
        "Get Price",
        "USAGE FILTER",
      ],
      vacuumFried: [
        "SHAPE FILTER",
        "FRUIT",
        "MUSHROOM",
        "SNACK",
        "Hot Product",
        "Out Of Stock",
        "VEGETABLE",
        "TEMPURA",
      ],
      shopDetail: [
        "Size：",
        "Ingredient：",
        "Packing：",
        "Origin：",
        "ITEM CODE:",
        "CONTACT FOR PRICE",
        "HOT PRODUCTS",
        "Home",
      ],
    },
  ],
  components: [
    {
      footer: {
        title: ["CATEGORIES", "LINKS", "CONTACT US", "SOCIAL MEDIA", "home"],
        CATEGORIES: [
          "Freeze Dried",
          "Vacuum Fried",
          "Semi Dried",
          "Toasted Dried",
          "Air Dried",
          "Nut",
        ],
        LINKS: [
          "Home",
          "About US",
          "Specialize",
          "Catalogs",
          "Cooperation Case",
          "Contact US",
          "BLOG",
        ],
        Contact: [
          "GREEN CRISPY",
          "+86 13512282858",
          "tyler@greencrispy.com",
          "712, Wuyue Plaza B, ErBa Road, JinNan District, Tianjin, China, 300350",
        ],
        Social: ["Instagram", "Facebook", "Whatsapp", "Linkedin"],
      },
      headerNav: [
        "HOME",
        "ABOUT US",
        "SPECIALIZE",
        "QUALITY CONTROL",
        "INSPECTION REPORT",
        "CUSTOMIZED SOLUTION",
        "R&D SERVICE",
        "CATALOG",
        "COOPERATION CASE",
        "CONTACT",
        "SHOP",
        "BLOG",
      ],
      headerNavDep: [
        "FREEZE DRIED",
        "VACUUM FRIED",
        "SEMI DRIED",
        "TOASTED DRIED",
        // "CANDY",
        "AIR DIRED",
        "NUT",
      ],
      sidebarshop: [
        "712, Wuyue Plaza B, Erba Road, Jinnan",
        "District, Tianjin, China,300350",
      ],
    },
  ],
  blog:[
    'GREEN CRISPY BLOG',
    "Read More »",
    'Does freeze dried fruit have nutritional value？',
    'When it comes to fruits, people generally think that fresh fruits are the best, and dried fruits have little nutritional value - even if dietary fiber and minerals can be preserved, at least the vitamins and health-promoting ingredients are lost. In fact, this is not the case.',
    "June 24, 2025 · No Comments"
  ],
  articles:[
    {
      title:'Does freeze dried fruit have nutritional value？',
      content1:'When it comes to fruits, people generally think that fresh fruits are the best, and dried fruits have little nutritional value - even if dietary fiber and minerals can be preserved, at least the vitamins and health-promoting ingredients are lost. In fact, this is not the case.',
      content2:'The significance of eating fruits is not only in obtaining vitamin C, but also in the mineral elements such as potassium and magnesium, including dietary fiber, as well as various health-promoting ingredients such as carotenoids, anthocyanins, flavonoids, phenolic acids, etc. A large part of these ingredients can be preserved in dried fruits.',
      content3:'Many studies have shown that replacing low-nutrition snacks such as biscuits, potato chips, and sweets with an appropriate amount of dried fruits can help prevent cardiovascular and cerebrovascular diseases and will not promote obesity and diabetes.',
      content4:'There are many ways to make dried fruits such as sun drying, air drying, infrared drying, low temperature fry drying, freeze drying, etc. The taste and price of dried fruits dried by the first 3 methods are similar; low temperature fried fruits are hard and crisp, and a little more expensive; vacuum freeze dried fruits are crispy and the most expensive.',
      content5:'Studies have confirmed that freeze dried fruits are healthy foods and can be used to supplement fruit nutrition.',
      content6:'Why can food become dry in frozen? We know that water has three phase curve. In the frozen state, a small amount of water molecules fly out of the ice directly and turn into water vapor. This change is called "sublimation". During vacuum freezing, the fruit is first quickly frozen to sub-zero temperatures, so that the food is filled with many tiny ice crystals. Then the air is pumped out to reduce the air pressure. The water vapor sublimated from the ice crystals is also continuously pumped out, so the ice crystals in the food continue to turn into water vapor at low temperature. After a few hours, the food becomes dry. Because the ice crystals directly turn into vapor and quietly leave the food matrix, there are many gaps left inside the food, which makes it taste crispy.',
      content7:'It requires freezing and vacuuming, which consumes more electricity, so the cost is higher than traditional dehydration process. However, this process also has great advantages. First, vacuuming solves the problem that many nutrients and antioxidant ingredients are easily oxidized during processing, such as vitamin C, vitamin A, vitamin E, folic acid, and antioxidant ingredients such as anthocyanins, flavonoids and carotenoids; secondly, low-temperature freezing solves the problem that some vitamins and phytochemicals are afraid of heat, such as vitamin C, vitamin B1, folic acid, etc., as well as health-care ingredients such as anthocyanins and glucosinolates.',
      content8:'Because it is not cooked, there is no loss of water-soluble healthy ingredients such as vitamin C, B vitamins, anthocyanins, flavonoids, chlorogenic acid, etc.; because it is not fried, there is no problem of oil loss of fat-soluble healthy ingredients such as carotenoids and vitamin K; because it is dry enough to inhibit the growth of microorganisms, there is no need to add preservatives; because the sugar in the fruit is concentrated, it is sweet no need add sugar.',
      content9:'Freeze dried fruits are suitable for all kinds of people',
      content10:"Freeze dried fruit is convenient to carry, and can be eaten in small amounts and multiple times, which solves some people's concerns about eating fruit, such as 'being afraid of cold when eating fruit before meals', 'being afraid of cold when eating fruit in the morning', 'fruit hurts the stomach', etc. Using small packages of freeze dried fruit to replace biscuits, snacks and potato chips has lower calories and higher nutritional value.",
      content11:'Studies have shown that the glycemic index of freeze dried fruit is at the same level as fresh fruits, and is also more friendly to diabetic patients.',
      content12:'And usually freeze dried fruit are gluten free, vegan, non-GMO, allergens free. People can eat it no worries.',
      content13:'However, freeze dried fruits have many gaps and easy to absorb moisture from air. Foods with porous structures will also turn bad quickly if left at room temperature for a long time. Therefore, freeze dried fruits are usually packaged in vacuum aluminum foil bag, light-proof and oxygen-proof packaging, and should be eaten quickly after opening the package.',
      content14:'Whether you want to build a healthy snack brand or develop freeze dried fruit ingredients for food industry, feel free to contact us. We Green Crispy focus on freeze dried fruit from 2003. We are specialize in produce and develop high quality freeze dried fruit products. ',
    }
  ]
};
